
import page from "~/layouts/testimonial.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Création de site web pour conseillère en aromathérapie | ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Spécialisée dans l’art du Reiki et le bien-être, Stéphanie souhaitait avoir une présence en ligne qui lui ressemble et qui met en valeur son savoir-faire !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Création site web",
        },
        {
          hid: "og:description",
          property: "og:description",
          content: "Reiki & Bergamotte",
        },
      ],
    };
  },
};
